import axiosInstance from "./service-instance";

const getAccountSummary = (case_id) =>
    axiosInstance.get("/company/facility/account/summary/", {
        headers: {
            "Content-Type": "application/json"
        },
        params: {
            case_id
        }
    });

const getAccountStatement = (case_id, start_date, end_date) =>
    axiosInstance.get("/company/facility-acc-stmt/", {
        headers: {
            "Content-Type": "application/json"
        },
        params: {
            case_id,
            start_date,
            end_date
        }
    });

const getOpenInvoices = (case_id) =>
    axiosInstance.get("/company/facility-acc-open-invoices/", {
        params: {
            case_id
        }
    });

export default {
    getAccountStatement,
    getAccountSummary,
    getOpenInvoices
};